import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { toggleAudio } from "../../redux/slices/videoSlice";

const AudioRap = styled.div`
  .all-the-audios {
    background: #000000;
    position: relative;
  }
  .upper-audio {
  }
  .red-rounded {
    width: 10px;
    border-radius: 50%;
    background: #ed1c24;
    height: 10px;
  }
  .audio-upper-middle p {
    color: #eff0fa;
    font-weight: 600;
    font-size: 14px;
  }
  .audio-upper-middle span {
    color: #c5c6d0;
    font-weight: 400;
    font-size: 14px;
  }
  .audio-upper-middle {
    border: 1px solid #272a31;
    width: 134px;
    height: 40px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
  }
  .audio-upper-last p {
    color: #d5d5d5;
    font-weight: 400;
    font-size: 12px;
  }
  .audio-upper-last {
    display: flex;
    align-items: center;
    gap: 5px;
    background: #242424;
    width: 164px;
    height: 44px;
    padding-left: 10px;
    border-radius: 100px;
  }
  .upper-audio {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }
  .cool-circle {
    border: 1px solid #d5d5d5;
    background: #e8e8e8;
    width: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
  }
  .middle-image-box {
    background: #1b1b1b;
    padding-left: 100px;
    padding-right: 20px;
    display: flex;
    border-radius: 16px;
    justify-content: space-between;
  }
  .middle-image-box.active {
    padding-left: 20px !important;
    width: 70%;
  }
  .audio-on-off-div {
    background: #232323;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    margin-top: 20px;
  }
  .middle-audio-image {
    height: 568px;
    width: 90%;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 47.01%,
        rgba(0, 0, 0, 0.12) 61.35%,
        rgba(0, 0, 0, 0.34) 78.82%,
        #000000 109.43%
      ),
      linear-gradient(0deg, rgba(0, 0, 0, 0.09), rgba(0, 0, 0, 0.09)),
      url("../images/audio-live-bg.png"); /* Replace with your image URL */

    background-size: cover; /* Adjust as needed */
    background-position: center;
    background-repeat: no-repeat;

    padding-bottom: 80px;
  }
  .listen-play {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
  }
  .the-moring-show-text {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    gap: 15px;
  }
  .middle-audio-image h4 {
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
  }
  .listners p {
    color: #ffffffcc;
    font-size: 14px;
    font-weight: 400;
  }
  .listners {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .middle-audio {
    padding: 20px;
  }
  .audio-mute {
    border: 1px solid var(--Border-Bright, #272a31);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90px;
    height: 48px;
    position: relative;
  }
  .last-audio button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    background: #ed1c24;
    width: 144px;
    height: 48px;
    border-radius: 100px;
    cursor: pointer;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    border-style: none;
  }
  .last-audio-right {
    display: flex;
    gap: 10px;
  }
  .last-rounded-div {
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #272a31;
    border-radius: 5px;

    align-content: center;
  }
  .last-audio {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    padding-bottom: 70px;
    position: relative;
  }
  .down-audio-middle p {
    color: #cccccc;
    font-size: 12px;
    font-weight: 400;
  }
  .down-audio-middle span {
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
  }
  .down-audio-middle {
    display: flex;
    align-items: center;
    gap: 3px;
  }
  .down-audio p {
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
  }
  .down-audio {
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: #008850;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
  }
  .share-div h4 {
    color: #eff0fa;
    font-size: 18px;
    font-weight: 500;
  }
  .share-div p {
    color: #d5d5d5;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    max-width: 287px;
  }
  .share-link-div {
    border: 1px solid #444954;
    width: 307px;
    height: 45px;
    border-radius: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px;
  }
  .share-link-div p {
    font-size: 12px;
    font-weight: 400;
    color: #eff0fa;
  }
  .share-div {
    background: #1b1b1b;
    border: 1px solid #272a31;
    border-radius: 12px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    width: 355px;
    position: absolute;
    right: 150px;
    top: -190px;
  }
  .part-header-sub {
    background: #2d2d2d;
    width: 312px;
    padding: 5px;
    border-radius: 10px;
  }
  .part-header-sub h4 {
    background: #3f3f3f;
    width: 148px;
    height: 36px;
    align-content: center;
    color: #eff0fa;
    font-size: 14px;
    font-weight: 600;
    border-radius: 6px;
    padding: 10px;
  }
  .part-header-1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .part-header-2 input {
    background: #2d2d2d;
    width: 352px;
    height: 48px;
    padding-left: 30px;
    border-radius: 10px;
    border-style: none;
  }
  .part-header-2 {
    width: 352px;
    position: relative;
  }
  .search-part-icon {
    position: absolute;
    left: 10px;
    top: 17px;
  }
  .part-header {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .part-body-header h5 {
    color: #8f9099;
    font-weight: 500;
    font-size: 14px;
  }
  .part-body-header-icon {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .part-body-header {
    border-bottom: 1px solid #2d2d2d;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 10px;
  }
  .stream-audio {
    background: #2d2d2d;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  .stream-icon-div {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .streamers p {
    color: var(--On-Surface-High, #eff0fa);
    font-size: 14px;
    font-weight: 400;
  }
  .streamers {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .part-body-inner {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 10px;
    position: relative;
  }
  .part-body {
    border: 1px solid #2d2d2d;
    width: 100%;
    border-radius: 8px;
  }
  .all-parts {
    background: #1b1b1b;
    padding: 20px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .middle-audio {
    display: block;
  }
  .middle-audio.active {
    display: flex;
    gap: 20px;
  }
  .action-inner-1 p {
    color: #eff0fa;
    font-size: 14px;
    font-weight: 500;
  }
  .action-inner-2 p {
    color: #f53f46;
    font-size: 14px;
    font-weight: 500;
  }
  .action-inner-1 {
    border-bottom: 1px solid #373737;
  }
  .action-inner-1,
  .action-inner-2 {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 20px;
  }
  .all-actions {
    background: #2d2d2d;
    border: 1px solid #3d3d3d;
    border-radius: 10px;
    position: absolute;
    right: 40px;
    top: 25px;
  }
  .participant-3-dot {
    position: relative;
  }
  .chart-1-sub h4 {
    color: var(--On-Surface-High, #eff0fa);
    font-size: 20px;
    font-weight: 600;
  }
  .chart-1-sub p {
    color: var(--On-Surface-Medium, #c5c6d0);
    font-size: 14px;
    font-weight: 400;
    max-width: 344px;
    text-align: center;
    line-height: 20px;
  }
  .chart-1-sub {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  .chart-1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;
    padding-top: 60px;
  }
  .chart-2-sub-1 p {
    color: var(--On-Surface-Medium, #c5c6d0);
    font-size: 12px;
    font-weight: 400;
  }
  .chart-2-sub-2 p {
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
  }
  .chart-2-sub-2 {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 8px;
    background: #6941c6;
    border-radius: 100px;
  }
  .chart-2-sub-1 {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .send-message-chat input {
    border-style: none;
    background: #2d2d2d;
    width: 352px;
    height: 48px;
    padding: 0px 20px;
    border-radius: 8px;
  }
  .send-message-chat {
    width: 352px;
    position: relative;
  }
  .chart-2 {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .send-icon {
    position: absolute;
    right: 10px;
    top: 15px;
  }
  .emoji-icon {
    position: absolute;
    right: 40px;
    top: 15px;
  }
  .all-charts {
    min-height: 500px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .down-following {
    border: 1px solid #272a31;
    width: 118px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: 6px;
  }
  .down-following p {
    color: #d5d5d5;
    font-size: 12px;
    font-weight: 400;
  }
  .last-audio-first,
  .last-audio-second {
    display: flex;
    gap: 10px;
    position: relative;
  }
  .last-audio-second-sub {
    border: 1px solid #272a31;
    width: 48px;
    height: 48px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .night-pharse-div h4 {
    color: #EFF0FA;
    font-size: 16px;
    font-size: 500;
  }
  .night-pharse-div  p {
    color: #D5D5D5;
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    max-width: 306px;

  }
  .night-pharse-div  {
    background: #1B1B1B;
    border: 1px solid #272A31;
    border-radius: 12px;
    padding: 20px;
    width: 355px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    position: absolute;
    top: -150px;
    right: 80px;
  }
  .pre-sub-div-inner {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
  }
  .pre-sub-div-inner p {
    color: #EFF0FA;
    font-size: 14px;
    font-weight: 500;
  }
  .pre-sub-div {
    background: #1B1B1B;
    border: 1px solid var(--Border-Bright, #272A31);
    width: 238px;
    height: 104px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    padding: 20px;
    position: absolute;
    top: -120px;
    right: 20px;
  }
  .subscribe-body p {
    color: #828286;
    font-size: 14px;
    font-weight: 400;
  }
  .subscribe-body span {
    color: #eff0fa;
    font-weight: 500;
  }
  .subscribe-inner p {
    color: #828286;
    font-size: 14px;
    font-weight: 400;
  }
  .subscribe-inner h4 {
    color: #eff0fa;
    font-size: 14px;
    font-weight: 500;
  }
  .subscribe-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0px;
    border-bottom: 1px solid #2d2d2d;
  }
  .sub-sub-1 {
    padding: 20px;
    background: #2d2d2d;
    width: 536px;
    border-radius: 8px;
  }
  .sub-sub-1 p {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    max-width: 375px;
  }
  .subscribe-body h6 {
    color: #828286;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    max-width: 411px;
  }
  .subscribe-body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 30px;
  }
  .all-subscribe {
    border: 1px solid #2D2D2D;    background: #000000CC;
    background: #1B1B1B;
    border-radius: 16px;
  }
  .subscribe-btns button {
    border-style: none;
    width: 213px;
    height: 48px;
    border-radius: 100px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
  }
  .manage-sub-btn {
    background: #ED1C24;

  }
  .cancel-sub-btn {
    background: #474747;

  }
  .subscribe-btns {
    display: flex;
    gap: 20px;
  }
  .pref-header h4,
  .subscribe-header h4 {
    color: #eff0fa;
    font-size: 18px;

    font-weight: 600;
  }
  .pref-header,
  .subscribe-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px;
    border-bottom: 1px solid #2d2d2d;
  }
`;

const ListeningLive = () => {
  
  const { videoOn, audioOn } = useSelector((state) => state.video);
  const localVideoRef = useRef(null);
  const dispatch = useDispatch();

  const [openParticipant, setOpenParticipant] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  const [openShare, setOpenShare] = useState(false);
  const [streamActionPop, setStreamActionPop] = useState(false);
    const [openNight, setOpenNight] = useState(false)
const [openPreSub, setOpenPreSub] = useState(false)
  const [subscribePop, setSubscribePop] = useState(false);



 
  const handleSubscribePop = () => {
    setSubscribePop(!subscribePop);
    setOpenPreSub(false);
  };
const handleOpenPreSub = () =>{
    setOpenPreSub(!openPreSub)
}

    const handleOpenNight = () => {
        setOpenNight(!openNight)
    }

  const handleStreamActionPop = () => {
    setStreamActionPop(!streamActionPop);
  };
  const handleOpenParticipant = () => {
    setOpenParticipant(!openParticipant);
    setOpenShare(false);
    setOpenChat(false);
  };

  const handleOpenChat = () => {
    setOpenChat(!openChat);
    setOpenParticipant(false);
    setOpenShare(false);
  };

  const handleOpenShare = () => {
    setOpenShare(!openShare);
    setOpenChat(false);
    setOpenParticipant(false);
  };

  const handleAudioToggle = () => {
    if (localVideoRef.current && localVideoRef.current.srcObject) {
      const tracks = localVideoRef.current.srcObject.getAudioTracks();
      console.log("Audio Tracks:", tracks);
      tracks.forEach((track) => (track.enabled = !audioOn));
      dispatch(toggleAudio());
    } else {
      console.log("No audio tracks found");
    }
  };
  return (
    <AudioRap>
      <div className="all-the-audios">
        <div className="upper-audio">
          <img src="/images/icon-7.png" alt="" />
          <div className="audio-upper-middle">
            <div className="red-rounded"></div>
            <p>LIVE</p>
            <span>1:25</span>
          </div>
          <div>user</div>
        </div>
        <div className={`middle-audio ${openChat ? "active" : ""}`}>
          <div className={`middle-image-box  ${openChat ? "active" : ""}`}>
            <div className={`middle-audio-image ${openChat ? "active" : ""}`}>
              <div className="listen-play">
                <img src="/images/listen-play.png" alt="" />
              </div>
              <div className="the-moring-show-text">
                <h4>The Morning Show @CoolFM</h4>
                <div className="listners">
                  <Icon
                    icon="octicon:people-24"
                    width="18"
                    height="18"
                    style={{ color: "#FFFFFFCC" }}
                  />
                  <p>0 Listeners</p>
                </div>
              </div>
            </div>
        
          </div>
          <div>
            {openChat ? (
              <>
                <div className="all-parts">
                  <div className="part-header">
                    <div className="part-header-1">
                      <div className="part-header-sub">
                        <h4>Chats</h4>
                      </div>
                      <Icon
                        onClick={handleOpenChat}
                        icon="uil:times"
                        width="20"
                        height="20"
                        style={{ color: "#C5C6D0", cursor: "pointer" }}
                      />
                    </div>
                  </div>
                  <div className="all-charts">
                    <div className="chart-1">
                      <img src="/images/img-11.png" alt="" />
                      <div className="chart-1-sub">
                        <h4>Start a conversation</h4>
                        <p>
                          There are no messages here yet. Start a conversation
                          by sending a message.
                        </p>
                      </div>
                    </div>
                    <div className="chart-2">
                      <div className="chart-2-sub-1">
                        <p>To</p>
                        <div className="chart-2-sub-2">
                          <Icon
                            icon="octicon:people-24"
                            width="13"
                            height="13"
                            style={{ color: "#ffffff", cursor: "pointer" }}
                          />
                          <p>Everyone</p>
                          <Icon
                            icon="iconamoon:arrow-right-2-duotone"
                            width="13"
                            height="13"
                            style={{ color: "#ffffff", cursor: "pointer" }}
                          />
                        </div>
                      </div>
                      <div className="send-message-chat">
                        <input type="text" placeholder="Send a message..." />
                        <Icon
                          className="send-icon"
                          icon="majesticons:send-line"
                          width="24"
                          height="24"
                          style={{ color: "#C5C6D0", cursor: "pointer" }}
                        />
                        <img
                          className="emoji-icon"
                          src="/images/emoji-1.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="last-audio">
          <div className="last-audio-first">
            <div className="audio-upper-last">
              <div className="cool-circle">
                <img src="/images/cool.png" alt="" />
              </div>
              <p>CoolFM95.9</p>
            </div>
            <div className="down-following">
              <img src="/images/follow-icon.png" alt="" />
              <p>Following</p>
            </div>
          </div>

          <div className="last-audio-second">
            <div className="last-audio-second-sub">
              <img src="/images/sound.png" alt="" />
            </div>
            <div style={{
                background: openNight  ? "#242424" : 'transparent'
            }} onClick={handleOpenNight} className="last-audio-second-sub">
              <img src="/images/i-icon.png" alt="" />
            </div>
            <div className="last-audio-second-sub">
              <img src="/images/small-white-plu.png" alt="" />
            </div>
            <button>
              <img src="/images/icon-8.png" alt="" />
              End Live
            </button>
            {openNight ? (
                <>
                <div className="night-pharse-div">
                    <h4>Night of prasie</h4>
                    <p>Lorem ipsum dolor sit amet consectetur. Purus massa vulputate amet ac ut dignissim pharetra tristique. Est duis venenatis 
                        sit nisl amet nulla.</p>
                </div>
                </>
            ): ""}
          </div>

          <div style={{position:"relative"}} className="last-audio-right">
            <div onClick={handleOpenChat} className="last-rounded-div">
              <Icon
                icon="fluent-mdl2:office-chat"
                width="32"
                height="32"
                style={{ color: "#EFF0FA", cursor: "pointer" }}
              />
            </div>

            <div onClick={handleOpenShare} className="last-rounded-div">
              <Icon
                icon="ri:share-line"
                width="32"
                height="32"
                style={{ color: "#EFF0FA", cursor: "pointer" }}
              />
            </div>
            <div onClick={handleOpenPreSub} className="last-rounded-div">
              <Icon
                icon="akar-icons:three-line-horizontal"
                width="32"
                height="32"
                style={{ color: "#EFF0FA", cursor: "pointer" }}
              />
            </div>
            {openPreSub ? (
                <>
                <div className="pre-sub-div">
                    <div className="pre-sub-div-inner">
                        <img src="/images/prefs.png" alt="" />
                        <p>Preference</p>
                    </div>
                    <div onClick={handleSubscribePop} className="pre-sub-div-inner">
                        <img src="/images/subs.png" alt="" />
                        <p>Subscription</p>
                    </div>
                </div>
                </>
            ): ""}
          </div>
          {openShare ? (
            <>
              <div className="share-div">
                <h4>Share Event</h4>
                <p>
                  Share this event link with people, groups or audience you want
                  in your event.
                </p>
                <div className="share-link-div">
                  <p>https://pluglr.com/event/xzw-gxzn...</p>
                  <Icon
                    icon="si:copy-line"
                    width="20"
                    height="20"
                    style={{ color: "#EFF0FA", cursor: "pointer" }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
         <div>
                  {subscribePop ? (
                    <div className="dropdown-container">
                      <div className="all-subscribe">
                        <div className="subscribe-header">
                          <h4>Subscription</h4>
                          <Icon
                            onClick={handleSubscribePop}
                            icon="uil:times"
                            width="20"
                            height="20"
                            style={{ color: "#EFF0FA", cursor: "pointer" }}
                          />
                        </div>
                        <div className="subscribe-body">
                          <p>
                            Your monthly subscription: <span> Pluglr Premium</span>
                          </p>
                          <div className="subscribe-inner">
                            <p>Started</p>
                            <h4>20 March, 2024</h4>
                          </div>
                          <div className="subscribe-inner">
                            <p>Ends</p>
                            <h4>09 April, 2024</h4>
                          </div>
                          <div className="sub-sub-1">
                            <p>
                              Your Pluglr Premium subscription will automatically renew
                              on 09 Apr, 2024, and you'll be charged $9.99
                            </p>
                          </div>
        
                          <h6>
                            Click 'Manage subscription' to upgrade, downgrade, change
                            your card details or see your invoices.
                          </h6>
                          <div className="subscribe-btns">
                            <button className="manage-sub-btn">Manage Subscription</button>
                            <button className="cancel-sub-btn">Cancel Subscription</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
      </div>
    </AudioRap>
  );
};

export default ListeningLive;
